// RangeWithText.js

import React, { useState } from "react";
import { Box, RangeInput, Text, Grommet, ThemeContext } from "grommet";

const rangeInputTheme = {
    global: {
        spacing: "10px", // thumb size 
    }, 
    rangeInput: {
        track: {
            height: "4px",
            // lower: {
            //   color: "brand",
            //   opacity: 0.7
            // },
            // upper: {
            //   color: "dark-4",
            //   opacity: 0.3
            // },
            color: "dark-4"
        },
        thumb: {
            color: "neutral-3",    
        },
    },
};

const RangeWithText = (props) => {
    const {rangeOptions, actualValue, actualLabel, actualLabelOnly, transparent} = props;
    // console.log('In RangeWithText props: >> ', props);
    const [thumbColor, setThumbColor] = useState(props.pointColor); // Dynamic color state

    return (
        <Grommet theme={rangeInputTheme}>
            <ThemeContext.Extend
                value={{
                    rangeInput: {
                        thumb: {
                            color: thumbColor, // Override thumb color dynamically
                        },
                    },
                }}
            >

            <Box height={actualLabelOnly ? "60px" : "120px"} 
                width={actualLabelOnly ? "220px" : "300px"} justify="end" 
                background={transparent ? "" : "lightyellow"} border = {transparent ? false : true} round="10px"
                >
                <Box  height={actualLabelOnly ? "50px" : "120px" } style={actualLabelOnly ? {position:"relative", left: "0"}  : {position:"relative", left: "-15px"}} >
                    <Box  direction="row" justify="between" pad="0"  width="medium" >
                        {!actualLabelOnly && rangeOptions.length > 0 && rangeOptions.map (el =>
                        <Box key={el.label} style={{position:"relative", left: "-10px", bottom: "-10px"}}
                            >
                            <Text style={{transform: "rotate(-70deg)", display: "inline", width: "150px" }} weight="bold"
                                size="small" > {el.label.substring(0, 12)} </Text>
                        </Box>
                        )}
                    </Box>                    
                    {actualLabelOnly && actualLabel !== "" && (
                    <Box  style={{position:"relative", left: "30px"}} >
                        <Text  weight="bold" size="small" > {actualLabel} </Text>
                    </Box>
                    )}
                    <Box direction="row" alignSelf="center" gap="medium"  height="5px"
                        style={{position:"absolute", left: "30px", bottom: "20px"}} 
                        width={actualLabelOnly ? "80%" : rangeOptions.length === 2 ? "60%" : rangeOptions.length > 4 ? "90%" : "80%"} >
                        <RangeInput 
                            max={rangeOptions[rangeOptions.length - 1].value}
                            min={rangeOptions[0].value}
                            value={actualValue}
                            readOnly={true}
                            onChange={()=>{}}
                        />
                    </Box>
                    <Box direction="row"  justify="between" alignSelf="center" gap="medium" 
                        style={actualLabelOnly && rangeOptions.length > 5 ? {position:"absolute", left: "25px", bottom: "-2px"} : {position:"absolute", left: "30px", bottom: "-2px"}} 
                        height="20px" 
                        width={actualLabelOnly ? "80%" : rangeOptions.length === 2 ? "60%" : rangeOptions.length > 4 ? "90%" : "80%"} >
                        {rangeOptions.length > 0 && rangeOptions.map (el =>
                        <Box key={Math.random(100)} >
                            <Text weight="bold" margin={{horizontal: "xsmall"}} size="small" > {el.range} </Text>
                        </Box> 
                        )}
                    </Box>
                </Box>
            </Box>
            </ThemeContext.Extend>
        </Grommet>

        
    );
};
export default RangeWithText;
